import React from 'react'

import FunnelHeader from '../shared/FunnelHeader'
import FunnelSubHeader from '../shared/FunnelSubheader'
import OnboardingCards from './OnboardingCards'
import PlanCards from './PlanCards'

import {Control, Experiment, Variant} from '../GoogleOptimize'

interface Props {
  influxdbURL: string
}

const {paygCredit: paygCreditConfig} = window.Config

const FunnelPlans = ({influxdbURL}: Props): JSX.Element => {
  return (
    <Experiment id={paygCreditConfig.id}>
      <Control id="0">
        <FunnelHeader text="Want a plan with more?" />
        <FunnelSubHeader text="You can upgrade later at any time." />
        <PlanCards influxdbURL={influxdbURL} />
      </Control>
      <Variant id="1">
        <FunnelHeader text="Want a plan with more?" />
        <FunnelSubHeader text="Go usage-based, pay for only what you use." />
        <OnboardingCards influxdbURL={influxdbURL} />
      </Variant>
    </Experiment>
  )
}

export default FunnelPlans
